var _circle, _circle2, _circle3, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmoji32(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#FFCC4D",
    cx: 18,
    cy: 18,
    r: 18
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "#F4F7F9",
    cx: 24.5,
    cy: 13.5,
    r: 5.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    fill: "#F4F7F9",
    cx: 11.5,
    cy: 13.5,
    r: 5.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#65471B",
    d: "M23.109 23.424c-2.763-.667-8.873-.06-11.162 4.405-.082.158-.04.353.1.464.068.055.151.082.234.082.085 0 .171-.029.241-.087 3.084-2.58 7.436-2.58 10.036-2.58 1.635 0 2.536 0 2.536-.708s-.705-1.268-1.985-1.576zM10.5 13c1.381 0 2.5-1.119 2.5-2.5 0-1.252-.923-2.28-2.124-2.462-.79.089-1.526.348-2.178.736C8.268 9.223 8 9.829 8 10.5c0 1.381 1.119 2.5 2.5 2.5zm13 0c1.381 0 2.5-1.119 2.5-2.5 0-1.252-.923-2.28-2.124-2.462-.789.089-1.526.348-2.177.736C21.268 9.223 21 9.829 21 10.5c0 1.381 1.119 2.5 2.5 2.5z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmoji32);
export default __webpack_public_path__ + "static/media/emoji32.7ba5b2d4e180afbcc26a7f5f44832e06.svg";
export { ForwardRef as ReactComponent };